const a = {
  borderRadius: 4
};
export {
  a as default
};
